export const formatWordsFromCamelCase = (str?: string): string => {
    if (!str) {
        return ''
    }

    return str
        .charAt(0)
        .toUpperCase()
        .concat(str.substring(1))
        .replace(/([a-z]{1,})([A-Z])/g, '$1 $2')
}
